<template>
  <div class="plus-tools">
    <el-scrollbar class="formBox" v-scrollbar-height>
      <el-page-header @back="$emit('toggle',{name:'QuickNav'})" content="插件工具" class="pageHead" />
      <div class="card">
        <el-row :gutter="16" style="width:100%">
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="8">
            <!-- 计算几天后的日期 -->
            <el-card class="box-card">
              <div slot="header" class="title">
                <span>计算几天后的日期</span>
              </div>
              <date-calculation />
            </el-card>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="8">
            <!-- 计算日期差 -->
            <el-card class="box-card">
              <div slot="header" class="title">
                <span>计算日期差</span>
              </div>
              <date-diff />
            </el-card>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="8">
            <!-- 人民币大写转换 -->
            <el-card class="box-card">
              <div slot="header" class="title">
                <span>人民币大写转换器</span>
              </div>
              <toggle-case />
            </el-card>
          </el-col>
        </el-row>
      </div>
    </el-scrollbar>
  </div>
</template>
<script>
import ToggleCase from './toggleCase'
import DateCalculation from './dateCalculation'
import DateDiff from './dateDiff'
export default {
  name: 'PluginTools',
  components: {
    DateDiff,
    ToggleCase,
    DateCalculation,
  },
}
</script>
<style lang="less" scoped>
.plus-tools {
  background-color: #fff;
  padding: 0 24px;
  border-radius: 8px;
  .pageHead {
    padding: 16px 0;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    :deep(.el-page-header__title) {
      font-size: 16px;
    }
  }
  .card {
    display: flex;
    align-items: flex-start;
    margin-left: 16px;
  }
  .box-card {
    width: 100%;
    margin-bottom: 16px;
    :deep(.el-card__body) {
      padding-bottom: 16px;
    }
  }
  .title {
    font-size: 16px;
    font-weight: bold;
    color: #303133;
  }
}
</style>
